import React, { FC } from 'react';

import useStyles from './styles';

interface Props {
  height?: number | string;
  width?: number | string;
}

const Block: FC<Props> = ({ height, width }) => {
  const classes = useStyles();

  const style = {
    height,
    width,
    borderRadius: 4,
  };

  return <div style={style} className={classes.animation} />;
};

Block.defaultProps = {
  height: 12,
  width: 100,
};

export default Block;
